const PRODUCT_TYPE = {
  PHOTO_PRODUCT: 201, //摄影
  PLAY_PRODUCT: 101, //游乐
  COURSE_OFFLINE: 501, //班课
  COURSE_ONE_ON_ONE: 502, //1对1
  SCENIC_PRODUCT: 601, //景区
  YU_ER: 402 //育儿商品
}

export const getTabTitle = (spuType, cate4Id) => {
  if (PRODUCT_TYPE.PHOTO_PRODUCT === +spuType) {
    return '套餐详情'
  } else if (
    PRODUCT_TYPE.COURSE_OFFLINE === +spuType ||
    PRODUCT_TYPE.COURSE_ONE_ON_ONE === +spuType
  ) {
    return '课程详情'
  } else if (PRODUCT_TYPE.PLAY_PRODUCT === +spuType) {
    return '商品详情'
  } else if (PRODUCT_TYPE.YU_ER === +spuType) {
    //产康
    if (parseInt(+cate4Id / 100) === 101121) {
      return '套餐详情'
    } else if (+cate4Id === 10111110) {
      return '商品详情'
    }
  }
  return '服务详情'
}

export const getPageTitle = (spuType, cate4Id) => {
  if (
    PRODUCT_TYPE.COURSE_OFFLINE === +spuType ||
    PRODUCT_TYPE.COURSE_ONE_ON_ONE === +spuType
  ) {
    return '课程详情'
  } else if (PRODUCT_TYPE.PLAY_PRODUCT === +spuType) {
    return '商品详情'
  } else if (PRODUCT_TYPE.YU_ER === +spuType) {
    if (+cate4Id === 10111110) {
      return '商品详情'
    }
  }
  return '服务详情'
}

export default PRODUCT_TYPE
